import React from 'react';
export default function Lead({ body, title }) { return /*#__PURE__*/ React.createElement("section", { className: "landing-page__lead" }, /*#__PURE__*/ React.createElement("h2", null, title), /*#__PURE__*/ React.createElement("p", null, body)); }
